import * as React from 'react';
import kara from '../../../../../assets/images/static_pages/kara_bakery.svg';
import tilda from '../../../../../assets/images/static_pages/tilda_marketing_team.svg';
import pats from '../../../../../assets/images/static_pages/pats_health_services.svg';

export const WhichPlan = () => {
  const datas = [
    {
      plan: 'Lite',
      color: '#00AA8B',
      users: 2,
      balance: 50,
      topUp: 'every month',
      title: 'Kara Bakery',
      body: 'Alice runs a bakery and wants two employees to manage her orders.',
      image: kara,
    },
    {
      plan: 'Standard',
      color: '#E64500',
      users: 1,
      balance: 350,
      topUp: 'every week',
      title: 'Tilda Marketing Team',
      body: 'Tilda automates notifications to her followers once a week about latest deals, discounts, and upcoming events.',
      image: tilda,
    },
    {
      plan: 'Premium',
      color: 'black',
      users: 200,
      balance: 2000,
      topUp: 'when balance is below $500',
      title: 'Pat’s Health Services',
      body: "Pat staffs a 24/7 call center for hospitals across the West Coast. Her team of 200 agents relies on Avochato's Salesforce Integration to seamlessly send and receive calls and text messages.",
      image: pats,
    },
  ];

  const handleContactUsClick = () => {
    Object.keys(window.Avochato.widgets).forEach((key) => {
      window.Avochato.widgets[key].openWithOption('lead');
    });
  };

  const sections = datas.map((data) => (
    <div key={data.plan} className="col-section">
      <p className="plan-header" style={{ background: data.color }}>{data.plan}</p>
      <img src={data.image} />
      <p className="fsz-20 bold-800 mt-15">{data.title}</p>
      <div className="flex-col justify-center align-center mt-15 mb-5">
        <p className="dark-green fsz-14 bold-800">
          {data.users}
          &nbsp;
          {data.users > 1 ? 'Users' : 'User'}
        </p>
        <p className="dark-green fsz-14 bold-800">
          Account Balance:&nbsp;
          $
          {data.balance}
        </p>
        <p className="dark-green fsz-12">
          Auto top-up&nbsp;
          {data.topUp}
        </p>
      </div>
      <p className="fsz-14 mt-5 center">{data.body}</p>
    </div>
  ));

  return (
    <div id="which-plan">
      <p className="sub-header">What plan should I get?</p>
      <p className="header mb-5">Need help figuring out what’s the best plan for you?</p>
      <p className="fsz-14">Below are some examples of Avochato’s Customers</p>
      <div className="section-containers">
        {sections}
      </div>
      <br />
      <br />
      <p className="support">
        Still need help?&nbsp;
        <span
          style={{ cursor: 'pointer' }}
          role="button"
          tabIndex={0}
          onKeyPress={handleContactUsClick}
          onClick={handleContactUsClick}
          className="link-blue bold-800"
        >
          Chat with us
        </span>
      </p>
    </div>
  );
};
